import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { BasketViewComponentDef } from '@df/basket/view/basket-view.component.def';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { OrderByPipe } from '@df/ui/common/order-by.pipe';
import { ValuesPipe } from '@df/ui/common/values.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { merge } from 'rxjs/internal/observable/merge';
import { CheckoutMinibasketItemComponent } from '../basket/checkout-minibasket-item.component';
import { CouponRemoveComponent } from '../basket/coupon-remove.component';
import { GiftboxCheckoutItemComponent } from '../basket/giftbox/giftbox-checkout-item.component';
import { BasketDecorator } from '../customer/api/basket/basket.decorator';
import { GiftcardsAddedGiftcardComponent } from '../module/giftcards/giftcards-added-giftcard.component';
import { StoreCreditRemoveComponent } from '../module/store-credit/remove/store-credit-remove.component';
import { GiftboxBasketItem } from './../basket/giftbox/giftbox-basket-item';
import { GiftboxService } from './../basket/giftbox/giftbox.service';
import { CheckoutFormComponent } from './checkout-form.component';
import { CheckoutMinibasketContentBlockComponent } from './checkout-minibasket-content-block.component';

@Component({
    selector: 'checkout-minibasket',
    templateUrl: './checkout-minibasket.html',
    standalone: true,
    imports: [
        CheckoutMinibasketContentBlockComponent,
        CheckoutMinibasketItemComponent,
        CouponRemoveComponent,
        GiftboxCheckoutItemComponent,
        GiftcardsAddedGiftcardComponent,
        IfSizeDirective,
        NgClass,
        OrderByPipe,
        PriceComponent,
        StoreCreditRemoveComponent,
        TranslatePipe,
        ValuesPipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutMinibasketComponent extends BasketViewComponentDef implements OnInit {
    @Input()
    checkoutFormComponent: CheckoutFormComponent;

    @Input()
    closePopup?: () => void;

    protected giftboxService = inject(GiftboxService);

    giftboxBasketItems: GiftboxBasketItem[] = [];

    override get basket(): BasketDecorator {
        return <BasketDecorator>this.app.customer.basket;
    }

    override ngOnInit() {
        this.subscriptions.add(
            merge(
                this.app.events.on(Checkout.EVENTS.TotalsUpdate),
                this.basket.basketUpdateSubject,
                this.app.client.obs.resize,
                this.app.client.obs.breakpoint
            ).subscribe(() => this.detectChanges())
        );

        this.basket.preloadData();

        this.subscriptions.add(this.basket.basketUpdateSubject.subscribe(() => this.onBasketUpdate()));
        this.onBasketUpdate();
    }

    protected async onBasketUpdate(): Promise<void> {
        if (this.basket.data.gifting?.items?.length) {
            this.giftboxBasketItems = await this.giftboxService.getBoxItems();

            this.detectChanges();
        } else {
            this.giftboxBasketItems = [];
        }

        this.detectChanges();
    }

    protected detectChanges(): void {
        this._ref.detectChanges();
    }
}
